// eslint-disable-next-line no-unused-vars
import api from "../../api/wedrive";
import { mask } from 'vue-the-mask'

// eslint-disable-next-line no-unused-vars
export default {
      directives: {
        mask
      },
    data () {
      return {
        validationRules: {
          required: v => !!v || window.$vue.$t('app.required-field'), //'Es necesario completar este campo',
          requiredBoolean: v => !(!v && v!==false) || 'Es necesario completar este campo',
          maxLength(v, maximum) { return (v || '').length <= maximum || 'El campo excede la longitud máxima permitida (' + maximum + ' caracteres)'; },
          rangeInt(v, minimum, maximum) { return ((v || '') >= minimum && (v || '') <= maximum) || 'El campo está fuera del rango permitido [ ' + minimum + ' - ' + maximum + ' ]'; },
          email: v => !v || /.+@.+\..+/.test(v) || window.$vue.$t('app.invalid-email'), //'No es un e-mail válido',
          dni: v =>  !v || this.validateDNI(v) || 'No es un DNI/NIE válido',
          phone: v => !v || /^[0-9]{9}$/.test(v) || 'No es un teléfono válido',
          date: v => !v || this.validateDate(v) || 'No es una fecha válida dd/mm/aaaa',
          time: v => !v || this.validateTime(v) || 'No es una hora válida hh::mm:ss',
        },
      }
    },
    methods: {      
      validateDate(value) {
        value = this.fixIEDate(value);

        if (value === undefined || value == null || value.length != 10) {
            return false;
        }

        var esValido = this.parseLocalDate(value);

        return esValido.getTime() === esValido.getTime();
      },
      validateTime(value) {
        if (value === undefined || value == null || value.length != 8) {
            return false;
        }

        var esValido = this.parseLocalTime(value);

        return esValido.getTime()===esValido.getTime();
      },
      fixIEDate(ieDate) {
          if (!ieDate || ieDate.length != 15) return ieDate;
          var actual = ieDate.replace(/\D/g,'');
          return actual.substring(0,2) + "/" + actual.substring(2,4) + "/" + actual.substring(4);
      },
      validateDNI(value) {
        value = value ? value.toUpperCase() : null;

        var esValido = /^([0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]|[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET])$/.test(value);

        if (esValido === false) {
            return false;
        }

        var letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKET";

        var nie = value.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');

        var letra1 = value.substr(-1);
        var posicion = parseInt(nie.substr(0, 8)) % 23;
        var letra2 = letrasValidas.charAt(posicion);

        return letra1 === letra2;
    },
    formatLongLocalDate(date) {
        if (!date) {
            date = new Date();
        }

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
        }

        return date.toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' });
    },
    formatLocalDate(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
        }

        return date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
      },
      formatLocalDateTime(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
        }

        return date.toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' })+ ' ' + date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      },
      formatLocalDateTimeWithFullYear(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
        }

        return date.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' })+ ' ' + date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      },
      formatLocalDateTimeWithoutSeconds(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
        }

        return date.toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' })+ ' ' + date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      },
      formatLocalTime(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
        }

        return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      },
      formatLocalTimeWithoutSeconds(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
        }

        return date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      },
      formatISODate(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            date = new Date(date); //la entrada son milisegundos
        }

        return date.toISOString().substring(0, 10);
      },
      parseLocalDate(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            return new Date(date); //la entrada son milisegundos
        }

        var parts = date.split('/');

        if (parts.length != 3) {
            return date;
        }

        var esValido = Date.parse(`${parts[2]}-${parts[1]}-${parts[0]}`);

        if (isNaN(esValido)) {
            return null;
        }

        return new Date(esValido);
      },
      parseLocalTime(time) {
        if (!time) {
            return null;
        }

        if (typeof time === 'number') {
            return new Date(time); //la entrada son milisegundos
        }

        if (time.split(':').length != 3) {
            return time;
        }

        var date = new Date();

        var esValido = Date.parse(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${time}`);

        if (isNaN(esValido)) {
            return null;
        }
        
        return new Date(esValido);
      },
      parseLocalDateTime(date) {
        if (!date) {
            return null;
        }

        if (typeof date === 'number') {
            return new Date(date); //la entrada son milisegundos
        }

        var parts = date.split('/')

        if (parts.length!=3) return date;

        return new Date(`${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}T00:00:00`);
      },
      parseISODate(date) {
        if (!date) {
            return null;
        }

        const [year, month, day] = date.split('-')

        return new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`)
      },      
      esMatriculaORemolque(value) {
        value = value ? value.toUpperCase().replace(/[^0-9A-Z]/g, '') : null;

        var esValido = /^R?[0-9]{4}[A-Z]{3}$/.test(value);

        return esValido;
      },
      getFractalStreet(fractal) {
        var parts = fractal.split(',');
        
        if (parts.length != 8) {
            return '-';
        }

        return parts[0];
      },
      getFractalCodPostal(fractal) {
        var parts = fractal.split(',');
        
        if (parts.length != 8) {
            return '-';
        }

        return parts[1];
      },
      formatShortLocation(fractal) {
        var parts = fractal.split(',');
        
        if (parts.length != 8) {
            return fractal;
        }

        return parts[0] + ', ' + parts[4] + ', ' + parts[7];
      },
      parseTemperature(value) {
        var temp = parseInt(value);
        
        if (temp <= -1000) {
            return "-";
        }
        
        return (temp / 10);
      },
      formatTemperature(value) {
        var temp = parseInt(value);
        
        if (temp <= -1000) {
            return "-";
        }
        
        return (temp / 10) + 'ºC';
      },
      formatLatitudeLongitude(latitude, longitude) {
        var lat = this.parseLatitudeLongitude(latitude);
        var lng = this.parseLatitudeLongitude(longitude);

        return this.roundDecimalPlaces(lat, 8) + ', ' + this.roundDecimalPlaces(lng, 8);
      },
      parseLatitudeLongitude(value) {
          return parseFloat(value) / 3600;
      },
      roundDecimalPlaces(number, places) {    
        return +(Math.round(number + "e+" + places)  + "e-" + places);
      },
      updateMobileData: function(cbok, cberr) {
        api.mobileGrid(
          (data) => {
            this.$store.commit('wedrive/setNumAttempts', 0);
            this.$store.commit('wedrive/setMobileData', data);
            this.$store.commit('wedrive/setLastUpdate', new Date().getTime());
            if (cbok) {
                cbok();
            }
          },
          (error) => {
            this.$log.error(error); 
            this.$store.commit('wedrive/increaseNumAttempts');
            if (cberr) {
                cberr(error);
            }
          }
        );
      }
    }
}